<template>
  <v-slide-y-transition>
    <v-sheet
      v-if="showBanner && !dismissed"
      color="white"
      class="position-fixed elevation-1 app-banner"
    >
      <v-container class="pa-0" fluid>
        <v-row
          no-gutters
          align="center"
          class="py-2 px-4 mx-auto banner-container"
        >
          <!-- Close Button -->
          <v-col cols="auto" class="mr-3">
            <v-btn
              icon
              small
              class="grey--text text--darken-1"
              @click="dismissBanner"
            >
              <v-icon small color="#666">mdi-close</v-icon>
            </v-btn>
          </v-col>

          <!-- App Icon -->
          <v-col cols="auto" class="mr-3">
            <v-avatar
              :size="
                $vuetify.breakpoint.xs ? 48 : $vuetify.breakpoint.sm ? 52 : 57
              "
              rounded="lg"
              class="elevation-3 app-icon"
            >
              <v-img :src="appIcon" alt="Boom app" />
            </v-avatar>
          </v-col>

          <!-- App Info -->
          <v-col>
            <div
              class="text-body-1 font-weight-medium black--text mb-1 app-title"
            >
              Boom
            </div>
            <div class="text-caption grey--text text--darken-1 app-subtitle">
              Real Estech
            </div>
          </v-col>

          <!-- Open Button -->
          <v-col cols="auto" class="ml-3">
            <v-btn
              :href="appStoreUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="white--text font-weight-bold text-caption open-button"
              :small="!$vuetify.breakpoint.xs"
              :x-small="$vuetify.breakpoint.xs"
              rounded
              depressed
            >
              OPEN
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-slide-y-transition>
</template>

<script>
import appIcon from '@/assets/images/app-icon.png'
import DeviceMixin from 'components/mixins/device-mixin'

export default {
  name: 'AppDownloadBanner',
  mixins: [DeviceMixin],

  props: {
    storageKey: {
      type: String,
      default: 'app_banner_dismissed',
    },
  },

  data() {
    return {
      dismissed: false,
      appIcon,
    }
  },

  computed: {
    appStoreUrl() {
      // Replace with your actual app store URLs
      const iosUrl =
        'https://apps.apple.com/il/app/boom-real-estech/id1541477965'
      const androidUrl =
        'https://play.google.com/store/apps/details?id=com.designedvr.designedvr&hl=en'

      return this.isIOS ? iosUrl : androidUrl
    },

    isIOS() {
      const userAgent = window.navigator.userAgent.toLowerCase()
      return /iphone|ipad|ipod/.test(userAgent)
    },

    isWebView() {
      const ua = navigator.userAgent.toLowerCase()

      return (
        // PWA detection
        window.matchMedia('(display-mode: standalone)').matches ||
        // iOS app detection
        ((ua.includes('iphone') || ua.includes('ipad')) &&
          !ua.includes('safari')) ||
        // Android app detection
        ua.includes('wv') ||
        // Custom app interfaces
        window.ReactNativeWebView !== undefined ||
        window.webkit?.messageHandlers !== undefined
      )
    },

    isOnboardingPath() {
      return this.$route && this.$route.path.startsWith('/onboarding')
    },
    showBanner() {
      return (
        this.isMobile &&
        !this.isWebView &&
        !this.isOnboardingPath &&
        !this.dismissed
      )
    },
  },

  mounted() {
    this.checkDismissalStatus()
  },
  methods: {
    checkDismissalStatus() {
      const dismissed = localStorage.getItem(this.storageKey)
      this.dismissed = dismissed === 'true'
    },

    dismissBanner() {
      this.dismissed = true
      localStorage.setItem(this.storageKey, 'true')
    },
  },
}
</script>

<style scoped>
/* iOS Smart App Banner Styling */
.app-banner {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 9999 !important;
  border-bottom: 1px solid #d1d1d6;
  background: #f7f7f7 !important;
  width: 100% !important;
}

.banner-container {
  max-width: 1200px;
}

.app-icon {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
}

.app-title {
  line-height: 1.3;
}

.app-subtitle {
  line-height: 1.2;
}

.open-button {
  background: #007aff !important;
  height: 32px !important;
  letter-spacing: 0.5px;
  min-width: 76px !important;
  box-shadow: none !important;
}

.open-button:hover {
  background: #0056b3 !important;
}
</style>
